import React from 'react';
import {
    Divider,
    ListItemIcon,
    Menu,
    MenuItem,
    Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { getProfileMenu } from '../../../utils/menusData';
import { useAuth } from '../../../contexts/AuthContext';
import useTranslate from '../../../customHooks/useTranslate';
import { useAppConfigurationSections } from '../../../contexts/AppConfigurationContext';
import Icon from '../../../muiComponents/Icon';

const ListUserMenu = props => {
    const { isMenuOpen, anchorEl, handleClose } = props;
    const translate = useTranslate();
    const { isProfileSectionVisible, profile } = useAppConfigurationSections();
    const { handleIsAuthenticated } = useAuth();

    const userMenu = getProfileMenu(isProfileSectionVisible, profile.pages);

    return (
        <Menu
            open={isMenuOpen}
            id='user-button'
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            {userMenu.map(item => {
                const { type, link, onClick } = item;
                switch (type) {
                    case 'divider':
                        return <Divider key={item.text} />;
                    default:
                        return (
                            <MenuItem
                                key={item.text}
                                sx={{ padding: 0 }}
                                onClick={() => {
                                    handleClose();
                                    if (onClick) {
                                        onClick();
                                        handleIsAuthenticated(false);
                                    }
                                }}
                            >
                                <Link
                                    to={link}
                                    className='user-menu__link'
                                    style={{
                                        width: '100%',
                                        padding: '6px 16px',
                                    }}
                                >
                                    <ListItemIcon>
                                        <Icon
                                            iconName={item.icon}
                                            fontSize='small'
                                        />
                                    </ListItemIcon>
                                    <Typography sx={{ fontWeight: 600 }}>
                                        {translate(item.text)}
                                    </Typography>
                                </Link>
                            </MenuItem>
                        );
                }
            })}
        </Menu>
    );
};

export default ListUserMenu;
